import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstPending: [],
		loading: false,
	},
	getters: {
		getLstPending: state => state.lstPending,
		getLoading: state => state.loading,
	},
	mutations: {
		setLstPending(state, lstPending) {
			state.lstPending = lstPending
		},
		setLoading(state, loading) {
			state.loading = loading
		},
	},
	actions: {
		async findPendingChecks({ commit, dispatch }, fn3contal) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/CheckClearance/FindPendingChecks/${fn3contal}`)
				.then(response => {
					let lstPending = (Utils.ValidateAxiosResponse(response.data) || []).map(item => ({ ...item.dr4, dr3datacon: item.dr3datacon }))
					commit("setLstPending", lstPending)
				})
				.catch(error => {
					commit("setLstPending", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		async compensate({ dispatch }, { fn3contal, dataBase, lstDr4cheque }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Compensando cheques", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.put("/Financial/CheckClearance/Compensate", { fn3contal, dataBase, lstDr4cheque })
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
